<div>
  <form [formGroup]="inputForm">
    <label [for]="button?.button_id">{{ button?.button_headline }}</label>
    <p *ngIf="button?.button_subhead" class="text-muted">
      {{ button?.button_subhead }}
    </p>
    <ng-container *ngFor="let item of options">
      <!-- <div class="form-check mb-2">
        <input
          type="radio"
          [name]="radioName"
          [id]="'positions-radio' + item.value"
          [value]="item.value"
          [checked]="item.id === f.value.value"
          class="form-check-input ng-untouched ng-pristine ng-valid"
          (click)="onChange(item)"
        />
        <label [for]="'positions-radio' + item.value" class="form-check-label">
          {{ item.label }}
        </label>
      </div> -->
      <div class="form-check mb-3">
        <input type="checkbox" [id]="item.id" [checked]="values[item.id]" (change)="onChange($event,item)" class="form-check-input" [disabled]="button?.button_disable"/>
        <label [for]="item.id" class="form-check-label"> {{ item.label }} </label>
      </div>
    </ng-container>

    <div *ngIf="f.value.errors" class="invalid-feedback">
      <div *ngIf="f.value.errors.required">
        {{ errorMsgList["required"] }}
      </div>
      <div *ngIf="f.value.errors.minlength">
        {{ errorMsgList["minlength"] }}
      </div>
      <div *ngIf="f.value.errors.maxlength">
        {{ errorMsgList["maxlength"] }}
      </div>
      <div *ngIf="f.value.errors.pattern">
        {{ errorMsgList["pattern"] }}
      </div>
    </div>
  </form>
</div>
